import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { Button, Select, Menu, Modal } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEllipsisV, faDownload, faLaptop } from '@fortawesome/free-solid-svg-icons';
import { faWindows, faLinux } from '@fortawesome/free-brands-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useContext, useRef } from 'react';
import { getUSBstatus, blockUSB, formatNonOSDrives } from '../../apis/agent';
import { editLastLogin, addOperation, addQueueOperation, editUsbStatus, requestOperation } from '../../apis/axios';
import ConformationDialog from '../common/ConfirmationModal';
import AuthContext from '../../AuthContext';
import { toast } from 'react-toastify'
// Columns definition
const columns = (usbStatuses, handleUSBAction,handleUnlicencedDeviceClick, handleEraseWithoutOS, handleNukeOS, loadingDevices, handleInactiveDeviceClick) => [
  {
    accessorKey: 'name',
    header: 'Device Name',
    size: 180,
    minSize: 120,
    Cell: ({ cell, row }) => {
      const deviceName = cell.getValue();
      const navigate = useNavigate();
      const isActive = parseInt(row.original.isActive) === 1;
      const isLicenced =parseInt(row.original.licenced) === 1; // Check licenced status

      return (
        <div
          className="flex items-center space-x-2 cursor-pointer group"
          onClick={() => {
            if (isActive && isLicenced) {
              navigate(`/drive-details/${deviceName}`, { state: { device: row.original  } });
            } else if (!isLicenced) {
              handleUnlicencedDeviceClick(); // Trigger unlicensed modalelse
            }
              else if(!isActive){
              handleInactiveDeviceClick();
            }
            else{
               navigate(`/drive-details/${deviceName}`, { state: { device: row.original  } });
            }
          }}
        >
          <FontAwesomeIcon icon={faLaptop} className="text-[#595C60] group-hover:text-[#FF7A00]" />
          <span className="text-[#595C60] group-hover:text-[#FF7A00]">
            {deviceName}
          </span>
        </div>
      );
    },
    mantineTableBodyCellProps: {
      style: {
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: 600,
        color: '#595C60',
      },
    },
  },
  {
    accessorKey: 'isActive',
    header: 'Status',
    size: 150,
    minSize: 100,
    Cell: ({ cell }) => {
      const status = cell.getValue();
      const displayStatus = parseInt(status) === 1 ? 'Active' : 'Inactive';
      const colors = {
        Active: { background: '#FF7A00', text: '#FFF3E5' },
        Inactive: { background: '#A0AEC0', text: '#EDF2F7' },
      };
      const { background, text } = colors[displayStatus];
      return (
        <span
          style={{
            backgroundColor: background,
            color: text,
            width: '94px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '9999px',
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          {displayStatus}
        </span>
      );
    },
    mantineTableBodyCellProps: {
      style: {
        fontFamily: 'Nunito Sans, sans-serif',
      },
    },
  },
  {
    accessorKey: 'department_name',
    header: 'Department',
    size: 180,
    minSize: 120,
    mantineTableBodyCellProps: {
      style: {
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: 600,
        color: '#595C60',
      },
    },
  },
  {
    accessorKey: 'os',
    header: 'OS',
    size: 150,
    minSize: 100,
    Cell: ({ cell }) => {
      const osName = cell.getValue();
      const isWindows = osName.toLowerCase().includes('windows');
      const icon = isWindows ? faWindows : faLinux;
      const iconColor = isWindows ? '#00B0FF' : '#202224';
      return (
        <div className="flex items-center space-x-2">
          <FontAwesomeIcon icon={icon} size="sm" style={{ color: iconColor }} />
          <span>{osName}</span>
        </div>
      );
    },
    mantineTableBodyCellProps: {
      style: {
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: 600,
        color: '#595C60',
      },
    },
  },
  {
    accessorKey: 'model',
    header: 'Model',
    size: 150,
    minSize: 120,
    mantineTableBodyCellProps: {
      style: {
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: 600,
        color: '#595C60',
      },
    },
  },
  {
    accessorKey: 'location',
    header: 'Location',
    size: 150,
    minSize: 120,
    mantineTableBodyCellProps: {
      style: {
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: 600,
        color: '#595C60',
      },
    },
  },
  {
    accessorKey: 'disks',
    header: 'Disks',
    size: 120,
    minSize: 80,
    mantineTableBodyCellProps: {
      style: {
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: 600,
        color: '#595C60',
      },
    },
  },
  {
    accessorKey: 'actions',
    header: 'Actions',
    size: 100,
    minSize: 80,
    Cell: ({ row }) => {
      const navigate = useNavigate();
      const deviceUUID = row.original.uuid;
      const usbStatus = row.original.usb_status || 'unknown';
      const usbActionLabel = usbStatus === 'block' ? 'Unblock USB' : 'Block USB';
      const isLoading = loadingDevices[deviceUUID] || false;
      const isActive = row.original.isActive === 1;

      return (
        <div className="flex justify-start items-center space-x-3 relative" style={{ backgroundColor: 'transparent' }}>
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="spinner"></div>
            </div>
          )}
          <FontAwesomeIcon
            icon={faEye}
            size="lg"
            className={`text-[#FF9F43] cursor-pointer hover:text-[#e68f3b] ${isLoading ? 'opacity-50 pointer-events-none' : ''}`}
            title="View"
            onClick={() => {
              if (isActive) {
                navigate(`/drive-details/${row.original.name}`, { state: { device: row.original } });
              } else {
                handleInactiveDeviceClick();
              }
            }}
          />
           {/* <Menu
            shadow="md"
            width={200}
            position="bottom-end"
            withinPortal={true}
            zIndex={1000}
            styles={{
              dropdown: {
                backgroundColor: '#ffffff',
                zIndex: 1000,
                position: 'absolute',
              },
              item: {
                backgroundColor: 'transparent',
                color: '#595C60',
                '&[data-hovered]': {
                  backgroundColor: '#FFF3E5',
                  color: '#595C60',
                },
                '&:hover': {
                  backgroundColor: '#FFF3E5',
                  color: '#595C60',
                },
              },
            }}
          >
            <Menu.Target>
              <FontAwesomeIcon
                icon={faEllipsisV}
                size="lg"
                className={`text-[#FF9F43] cursor-pointer hover:text-[#e68f3b] ${isLoading ? 'opacity-50 pointer-events-none' : ''}`}
                title="More"
              />
            </Menu.Target>

            <Menu.Dropdown>
             
 <Menu.Item
                onClick={() => handleNukeOS(row.original)}
                disabled={isLoading}
              >
                Nuke OS
              </Menu.Item> 
              <Menu.Item
                onClick={() => handleEraseWithoutOS(row.original)}
                disabled={isLoading}
              >
                Wipe w/o OS
              </Menu.Item>
              <Menu.Item
                onClick={() => handleUSBAction(row.original, usbStatus)}
                disabled={isLoading}
              >
                {usbActionLabel}
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>  */}
        </div>
      );
    },
    mantineTableBodyCellProps: {
      style: {
        height: '48px',
        backgroundColor: 'transparent !important',
        position: 'relative',
        zIndex: 1,
      },
    },
  },
];

// Function to export data as CSV
const exportToCSV = (data, filename) => {
  if (!Array.isArray(data)) {
    console.warn('exportToCSV: Data is not an array, defaulting to empty array.');
    return;
  }

  const headers = [
    'Device Name',
    'Status',
    'Department',
    'OS',
    'Model',
    'Location',
    'Disks',
  ];
  const rows = data.map(item => [
    item.name,
    item.isActive === 1 ? 'Active' : 'Inactive',
    item.department_name,
    item.os,
    item.model,
    item.location,
    item.disks,
  ]);

  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(',')),
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.click();
  URL.revokeObjectURL(url);
};

// Function to check device status
const checkDeviceStatus = async (device) => {
  try {
    if (!device.id) {
      throw new Error('Device ID is missing.');
    }
    if (!device.uuid) {
      throw new Error('Device UUID is missing.');
    }

    const device_id = device.id;
    const apiResponse = await editLastLogin({ id: device_id, uuid: device.uuid }, device.sys_uuid);
    const isActive = apiResponse.data.isActive === 1;
    return { isActive, device_id };
  } catch (error) {
    console.error(`Error checking device status for UUID ${device.uuid}:`, error.message);
    return { isActive: false, device_id: device.id };
  }
};

const DeviceTable = ({ data, handleUpdate }) => {
  const auth = useContext(AuthContext);
  const [usbStatuses, setUsbStatuses] = useState({});
  const [loadingDevices, setLoadingDevices] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUnlicencedModalOpen, setIsUnlicencedModalOpen] = useState(false); // New state for unlicensed modal
  const [modalConfig, setModalConfig] = useState({
    title: '',
    message: '',
    onConfirm: () => { },
    deviceUUIDs: [],
    actionType: '',
  });
  const [isInactiveModalOpen, setIsInactiveModalOpen] = useState(false);
  const previousActivityStatusRef = useRef({}); // Use ref to track previous activity status
const handleUnlicencedDeviceClick = () => {
    setIsUnlicencedModalOpen(true);
  };
  // Initialize previous activity status
  useEffect(() => {
    if (data && data.length > 0) {
      const updatedActivityStatus = data.reduce((acc, device) => {
        acc[device.uuid] = device.isActive === 1;
        return acc;
      }, {});
      previousActivityStatusRef.current = { ...previousActivityStatusRef.current, ...updatedActivityStatus };
    }
  }, [data]);

  // Fetch USB status for each device (initial load and refresh)
  // useEffect(() => {
  //   const fetchUSBStatuses = async () => {
  //     const statuses = {};
  //     for (const device of data) {
  //       if (device.uuid) {
  //         try {
  //           const response = await getUSBstatus(device.uuid, device.sys_uuid);
  //           statuses[device.uuid] = response.data.status || 'unknown';
  //           // Call editUsbStatus with the status obtained from getUSBstatus
  //         if (response.data.status !== 'unknown') {
  //           await editUsbStatus({
  //             id: device.id,
  //             status: response.data.status,
  //           });
  //         }
  //         } catch (error) {
  //           console.error(`Error fetching USB status for ${device.uuid}:`, error);
  //           statuses[device.uuid] = usbStatuses[device.uuid] || 'unknown'; // Fallback to previous status if available
  //         }
  //       }
  //     }
  //     setUsbStatuses(statuses);
  //   };

  //   if (data && data.length > 0) {
  //     fetchUSBStatuses();
  //   }
  // }, [data]); // Added usbStatuses to dependencies
  //console.log(data)
  // Detect when a device becomes active and sync USB status with backend
  // useEffect(() => {
  //   const syncUSBStatus = async () => {
  //     const currentActivityStatus = data.reduce((acc, device) => {
  //       acc[device.uuid] = device.isActive === 1;
  //       return acc;
  //     }, {});

  //     for (const device of data) {
  //       const deviceUUID = device.uuid;
  //       const isCurrentlyActive = device.isActive === 1;
  //       const wasPreviouslyActive = previousActivityStatusRef.current[deviceUUID] || false;

  //       // Detect transition from inactive to active
  //       if (isCurrentlyActive && !wasPreviouslyActive && deviceUUID) {
  //         try {
  //           setLoadingDevices(prev => ({ ...prev, [deviceUUID]: true }));
  //           const currentLocalStatus = usbStatuses[deviceUUID] || 'unknown';
  //           const backendResponse = await getUSBstatus(deviceUUID, device.sys_uuid);
  //           const backendStatus = backendResponse.data.status || 'unknown';

  //           // If local status doesn't match backend status, update backend
  //           if (currentLocalStatus !== backendStatus && backendStatus !== 'unknown') {
  //             await editUsbStatus({
  //               id: device.id,
  //               status: backendStatus,
  //             });
  //             setUsbStatuses(prev => ({
  //               ...prev,
  //               [deviceUUID]: backendStatus,
  //             }));
  //           }
  //         } catch (error) {
  //           console.error(`Error syncing USB status for device ${deviceUUID}:`, error);
  //         } finally {
  //           setLoadingDevices(prev => ({ ...prev, [deviceUUID]: false }));
  //         }
  //       }
  //     }

  //     // Update ref after processing
  //     previousActivityStatusRef.current = { ...currentActivityStatus };
  //   };

  //   if (data && data.length > 0) {
  //     syncUSBStatus();
  //   }
  // }, [data]); // Removed usbStatuses and previousActivityStatus from dependencies

  // Helper function to open confirmation modal
  const openConfirmationModal = (title, message, onConfirm, deviceUUIDs, actionType) => {
    setModalConfig({
      title,
      message,
      onConfirm,
      deviceUUIDs,
      actionType,
    });
    setIsModalOpen(true);
  };

  // Handler for inactive device click
  const handleInactiveDeviceClick = () => {
    setIsInactiveModalOpen(true);
  };

  // Handle USB block/unblock action for a single device
  const handleUSBAction = (device, currentStatus) => {
    const action = currentStatus === 'block' ? 'unblock' : 'block';
    const actionLabel = action === 'block' ? 'Block USB' : 'Unblock USB';
    const operationType = action === 'block' ? 'usb_blocking' : 'usb_unblock';
    openConfirmationModal(
      `Confirm ${actionLabel}`,
      `Are you sure you want to ${action} USB for this device?`,
      async () => {
        try {
          setLoadingDevices(prev => ({ ...prev, [device.uuid]: true }));
          const { isActive, device_id } = await checkDeviceStatus(device);
          let operationLogId;

          if (isActive) {
            const operationResponse = await addOperation({
              device_id: device_id,
              type: operationType,
              user_id: auth.user,
            });
            operationLogId = operationResponse.data.log_id;
            const res = await blockUSB(device.uuid, action, operationLogId, device.sys_uuid);
            //console.log(res.status)
            if (res.status === 200) {
              const response = await getUSBstatus(device.uuid, device.sys_uuid);
              if (response.status === 200) {
                await editUsbStatus({
                  id: device.id,
                  status: response.data.status,
                });
                handleUpdate()
              }
            }
          } else {
            const queueResponse = await addQueueOperation({
              device_id: device_id,
              type: operationType,
              user_id: auth.user,
            });
            operationLogId = queueResponse.data.log_id;
          }
        } catch (error) {
          console.error(`Error performing ${action} USB for device ${device.uuid}:`, error);
        } finally {
          setLoadingDevices(prev => ({ ...prev, [device.uuid]: false }));
        }
      },
      [device.uuid],
      `usb-${action}`
    );
  };
 
  // Handle Erase w/o OS for a single device
  const handleEraseWithoutOS = (device) => {
    openConfirmationModal(
      'Confirm Wipe w/o OS',
      'Are you sure you want to wipe all non-OS drives for this device? This action cannot be undone.',
      async () => {
        try {
          setLoadingDevices(prev => ({ ...prev, [device.uuid]: true }));
          const { isActive, device_id } = await checkDeviceStatus(device);
          let operationLogId;

          if (isActive) {
            const operationResponse = await requestOperation({
              device_id: device_id,
              type: 'delete_drive',
              user_id: auth.user,
            });
            operationLogId = operationResponse.data.log_id;
            await formatNonOSDrives(device.uuid, operationLogId, device.sys_uuid);
          } else {
            const queueResponse = await addQueueOperation({
              device_id: device_id,
              type: 'delete_drive',
              user_id: auth.user,
            });
            operationLogId = queueResponse.data.log_id;
          }
        } catch (error) {
          console.error(`Error performing Erase w/o OS for device ${device.uuid}`, error);
        } finally {
          setLoadingDevices(prev => ({ ...prev, [device.uuid]: false }));
        }
      },
      [device.uuid],
      'wipe-without-os'
    );
  };

  // Handle Nuke OS for a single device (placeholder implementation)
  const handleNukeOS = (device) => {
    openConfirmationModal(
      'Confirm Nuke OS',
      'Are you sure you want to nuke the OS for this device? This action will erase all data, including the operating system, and cannot be undone.',
      async () => {
        try {
          setLoadingDevices(prev => ({ ...prev, [device.uuid]: true }));
          // Placeholder: Implement actual API call for Nuke OS
        } catch (error) {
          console.error(`Error performing Nuke OS for device ${device.uuid}`, error);
        } finally {
          setLoadingDevices(prev => ({ ...prev, [device.uuid]: false }));
        }
      },
      [device.uuid],
      'nuke-os'
    );
  };




  // Handle bulk USB block/unblock action
  const handleBulkUSBAction = (selectedRows) => {
    const devices = selectedRows
      .map(row => row.original)
      .filter(device => device.uuid);
    if (devices.length === 0) return;

    const deviceUUIDs = devices.map(device => device.uuid);
    const allBlocked = deviceUUIDs.every(uuid => usbStatuses[uuid] === 'block');
    const allUnblocked = deviceUUIDs.every(uuid => usbStatuses[uuid] === 'unblock');
    const action = allBlocked ? 'unblock' : 'block';
    const actionLabel = action === 'block' ? 'Block USB' : 'Unblock USB';
    const operationType = action === 'block' ? 'usb_blocking' : 'usb_unblock';
    openConfirmationModal(
      `Confirm ${actionLabel}`,
      `Are you sure you want to ${action} USB for ${deviceUUIDs.length} selected device(s)?`,
      async () => {
        for (const device of devices) {
          try {
            setLoadingDevices(prev => ({ ...prev, [device.uuid]: true }));
            const { isActive, device_id: deviceId } = await checkDeviceStatus(device);
            let operationLogId;

            if (isActive) {
              const operationResponse = await addOperation({
                device_id: deviceId,
                type: operationType,
                user_id: auth.user,
              });
              operationLogId = operationResponse.data.log_id;
              const res = await blockUSB(device.uuid, action, operationLogId, device.sys_uuid);
              if (res.status === 200) {
                const response = await getUSBstatus(device.uuid, device.sys_uuid);
                if (response.status === 200) {
                  await editUsbStatus({
                    id: device.id,
                    status: response.data.status,
                  });
                }
              }
            } else {
              const queueResponse = await addQueueOperation({
                device_id: deviceId,
                type: operationType,
                user_id: auth.user,
              });
              operationLogId = queueResponse.data.log_id;
            }
          } catch (error) {
            console.error(`Error performing ${action} USB for device ${device.uuid}`, error);
          } finally {
            setLoadingDevices(prev => ({ ...prev, [device.uuid]: false }));
          }
        }
      },
      deviceUUIDs,
      `bulk-usb-${action}`
    );
  };

  // Handle bulk Erase w/o OS action
  const handleBulkEraseWithoutOS = (selectedRows) => {
    const devices = selectedRows
      .map(row => row.original)
      .filter(device => device.uuid);
    if (devices.length === 0) return;

    const deviceUUIDs = devices.map(device => device.uuid);
    openConfirmationModal(
      'Confirm Bulk Wipe w/o OS',
      `Are you sure you want to wipe all non-OS drives for ${deviceUUIDs.length} selected device(s)? This action cannot be undone.`,
      async () => {
        for (const device of devices) {
          try {
            setLoadingDevices(prev => ({ ...prev, [device.uuid]: true }));
            const { isActive, device_id: deviceId } = await checkDeviceStatus(device);
            let operationLogId;

            if (isActive) {
              const operationResponse = await addOperation({
                device_id: deviceId,
                type: 'delete_drive',
                user_id: auth.user,
              });
              operationLogId = operationResponse.data.log_id;
              await formatNonOSDrives(device.uuid, operationLogId, device.sys_uuid);
            } else {
              const queueResponse = await addQueueOperation({
                device_id: deviceId,
                type: 'delete_drive',
                user_id: auth.user,
              });
              operationLogId = queueResponse.data.log_id;
            }
          } catch (error) {
            console.error(`Error performing Erase w/o OS for device ${device.uuid}`, error);
          } finally {
            setLoadingDevices(prev => ({ ...prev, [device.uuid]: false }));
          }
        }
      },
      deviceUUIDs,
      'bulk-wipe-without-os'
    );
  };

  // Handle bulk Nuke OS action
  const handleBulkNukeOS = (selectedRows) => {
    const devices = selectedRows
      .map(row => row.original)
      .filter(device => device.uuid);
    if (devices.length === 0) return;

    const deviceUUIDs = devices.map(device => device.uuid);
    openConfirmationModal(
      'Confirm Bulk Nuke OS',
      `Are you sure you want to nuke the OS for ${deviceUUIDs.length} selected device(s)? This action will erase all data, including the operating system, and cannot be undone.`,
      async () => {
        for (const device of devices) {
          try {
            setLoadingDevices(prev => ({ ...prev, [device.uuid]: true }));
            // Placeholder: Implement actual API call for Nuke OS
          } catch (error) {
            console.error(`Error performing Nuke OS for device ${device.uuid}`, error);
          } finally {
            setLoadingDevices(prev => ({ ...prev, [device.uuid]: false }));
          }
        }
      },
      deviceUUIDs,
      'bulk-nuke-os'
    );
  };
//console.log(data)
  const table = useMantineReactTable({
    columns: columns(usbStatuses, handleUSBAction, handleUnlicencedDeviceClick,handleEraseWithoutOS, handleNukeOS, loadingDevices, handleInactiveDeviceClick),
    data: data || [],
    enableRowSelection: true,
    enableStickyHeader: true,
    enableColumnResizing: true,
    enableColumnHiding: true,
    enablePagination: true,
    initialState: {
      pagination: {
        pageSize: 10,
      },
    },
    mantineTableContainerProps: {
      style: {
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '400px',
        paddingLeft: '20px',
        paddingRight: '20px',
      },
    },
    mantineTableProps: {
      style: {
        minWidth: 'max-content',
        tableLayout: 'fixed',
        fontFamily: 'Nunito Sans, sans-serif',
        backgroundColor: '#ffffff',
        width: '100%',
      },
      className: 'shadow-sm rounded-lg',
    },
    mantineTableHeadCellProps: {
      style: {
        whiteSpace: 'nowrap',
        backgroundColor: '#F1F4F9',
        borderBottom: '1px solid #e5e7eb',
        padding: '12px',
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: '700',
        fontSize: '14px',
        color: '#202224',
      },
    },
    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        borderBottom: '0.5px solid #979797',
        backgroundColor: '#ffffff',
        '&:hover': {
          backgroundColor: '#f5f5f5 !important',
        },
        opacity: loadingDevices[row.original.uuid] ? 0.5 : 1,
        pointerEvents: loadingDevices[row.original.uuid] ? 'none' : 'auto',
        position: 'relative',
        zIndex: 1,
      },
    }),
    mantineTableBodyCellProps: {
      style: {
        whiteSpace: 'nowrap',
        padding: '12px',
        height: '48px',
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: '600',
        color: '#595C60',
        backgroundColor: 'transparent !important',
        '&:hover': {
          backgroundColor: 'transparent !important',
        },
      },
    },
    mantineSelectCheckboxProps: {
      size: 'sm',
      styles: {
        input: {
          '&:not(:checked)': {
            border: '1px solid #202224 !important',
            backgroundColor: 'transparent !important',
          },
          '&:checked': {
            border: 'none !important',
            backgroundColor: '#FF7A00 !important',
          },
        },
        icon: {
          color: '#ffffff !important',
        },
        wrapper: {
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'transparent !important',
        },
      },
      className: 'custom-checkbox-cell',
    },
    mantineSelectAllCheckboxProps: {
      size: 'sm',
      styles: {
        input: {
          '&:not(:checked)': {
            border: '1px solid #202224 !important',
          },
          '&:checked': {
            border: 'none !important',
            backgroundColor: '#FF7A00 !important',
          },
        },
        icon: {
          color: '#ffffff !important',
        },
        wrapper: {
          borderBottom: '1px solid #e5e7eb',
        },
      },
    },
    mantineColumnVisibilityToggleButtonProps: {
      sx: {
        color: '#FF7A00 !important',
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        border: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: '#FFF3E5',
        },
        '& svg': {
          color: '#FF7A00 !important',
        },
      },
    },
    mantineTableToolbarProps: {
      sx: {
        '& .mantine-Menu-item': {
          color: '#FF7A00 !important',
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '14px',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: '#FFF3E5 !important',
          },
        },
        '& .mantine-Menu-item[data-testid="mrt-column-visibility-show-all-button"], & .mantine-Menu-item[data-testid="mrt-column-visibility-hide-all-button"]': {
          color: '#FF7A00 !important',
          '&:hover': {
            backgroundColor: '#FFF3E5 !important',
          },
        },
      },
    },
    mantinePaginationProps: {
      styles: {
        root: {
          fontFamily: 'Nunito Sans, sans-serif',
        },
        control: {
          backgroundColor: '#FF7A00',
          color: '#fff',
          border: 'none',
          '&:hover': {
            backgroundColor: '#FF6B00',
          },
          '&[data-disabled]': {
            backgroundColor: '#A0AEC0',
            color: '#EDF2F7',
          },
        },
        select: {
          fontFamily: 'Nunito Sans, sans-serif',
          border: '0.6px solid #202224',
          borderRadius: '6px',
          backgroundColor: '#FCFDFD',
          '&:focus': {
            borderColor: '#FF6B00',
            outline: 'none',
          },
        },
      },
    },
  });

  // Determine the bulk action label based on the status of selected devices
  const selectedRows = table.getSelectedRowModel()?.rows || [];
  const selectedStatuses = selectedRows.map(row => usbStatuses[row.original.uuid] || 'unknown');
  let bulkUSBActionLabel;
  if (selectedRows.length === 0) {
    bulkUSBActionLabel = 'Block/Unblock USB';
  } else {
    const allBlocked = selectedStatuses.every(status => status === 'block');
    const allUnblocked = selectedStatuses.every(status => status === 'unblock');
    if (allBlocked) {
      bulkUSBActionLabel = 'Unblock USB';
    } else if (allUnblocked) {
      bulkUSBActionLabel = 'Block USB';
    } else {
      bulkUSBActionLabel = selectedStatuses.includes('unblock') ? 'Block USB' : 'Unblock USB';
    }
  }

  return (
    <div className="mb-5">
      <style>
        {`
          .custom-checkbox-cell,
          .custom-checkbox-cell * {
            background-color: transparent !important;
          }
          .custom-checkbox-cell:hover,
          .custom-checkbox-cell *:hover {
            background-color: transparent !important;
          }
          .mantine-Menu-item[data-testid="mrt-column-visibility-show-all-button"],
          .mantine-Menu-item[data-testid="mrt-column-visibility-hide-all-button"] {
            color: #FF7A00 !important;
            font-family: 'Nunito Sans, sans-serif' !important;
            font-size: 14px !important;
          }
          .mantine-Menu-item[data-testid="mrt-column-visibility-show-all-button"]:hover,
          .mantine-Menu-item[data-testid="mrt-column-visibility-hide-all-button"]:hover {
            background-color: #FFF3E5 !important;
          }
          .export-button {
            position: relative;
            overflow: hidden;
          }
          .export-button-ripple {
            position: absolute;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.4);
            transform: scale(0);
            animation: ripple 0.6s linear;
            pointer-events: none;
          }
          @keyframes ripple {
            to {
              transform: scale(4);
              opacity: 0;
            }
          }
          .spinner {
            width: 24px;
            height: 24px;
            border: 4px solid #FF7A00;
            border-top: 4px solid transparent;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="flex justify-between items-center mb-4">
        <h2 style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: '24px', fontWeight: 700, color: '#202224' }}>
          Devices
        </h2>
        <div className="flex items-center">
          <Button
            size="sm"
            variant="filled"
            className="export-button"
            styles={{
              root: {
                width: '120px',
                height: '36px',
                backgroundColor: '#FF7A00',
                borderRadius: '20px',
                padding: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                '&:hover': {
                  backgroundColor: '#FF7A00',
                },
              },
              label: {
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 500,
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              },
            }}
            onClick={(e) => {
              const button = e.currentTarget;
              const ripple = document.createElement('span');
              const diameter = Math.max(button.clientWidth, button.clientHeight);
              const radius = diameter / 2;

              ripple.style.width = ripple.style.height = `${diameter}px`;
              ripple.style.left = `${e.clientX - button.getBoundingClientRect().left - radius}px`;
              ripple.style.top = `${e.clientY - button.getBoundingClientRect().top - radius}px`;
              ripple.classList.add('export-button-ripple');

              button.appendChild(ripple);

              setTimeout(() => {
                ripple.remove();
              }, 600);

              exportToCSV(data, 'devices.csv');
            }}
          >
            <FontAwesomeIcon
              icon={faDownload}
              style={{
                height: '10px',
                width: '10px',
                color: '#fff',
              }}
            />
            <span>Export</span>
          </Button>
          <div style={{ width: '30px' }} />
          
        </div>
      </div>
      <MantineReactTable table={table} />
      <ConformationDialog
        open={isModalOpen}
        title={modalConfig.title}
        message={modalConfig.message}
        onConfirm={() => {
          modalConfig.onConfirm();
          setIsModalOpen(false);
        }}
        onCancel={() => setIsModalOpen(false)}
        confirmLabel="Confirm"
        cancelLabel="Cancel"
      />
      <Modal
        opened={isInactiveModalOpen}
        onClose={() => setIsInactiveModalOpen(false)}
        title="Device Inactive"
        centered
        withCloseButton={false}
        styles={{
          title: {
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '20px',
            fontWeight: 700,
            color: '#202224',
          },
          body: {
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '16px',
            color: '#595C60',
          },
          content: {
            borderRadius: 'none',
            border: 'none',
            boxShadow: '6px 6px 6px #00000040',
          },
        }}
      >
        <div>
          <p>
            This device is currently inactive. You cannot access the drive details page for inactive devices. Please ensure the device is active to view its details.
          </p>
          <div className="flex justify-end mt-4">
            <Button
              onClick={() => setIsInactiveModalOpen(false)}
              styles={{
                root: {
                  border: 'none ',
                  backgroundColor: '#FF7A00',
                  borderRadius: '20px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                  '&:hover': {
                    backgroundColor: '#FF6B00',
                  },
                },
                label: {
                  fontFamily: 'Nunito Sans, sans-serif',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#fff',
                },
              }}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        opened={isUnlicencedModalOpen}
        onClose={() => setIsUnlicencedModalOpen(false)}
        title="Device Not Licenced"
        centered
        withCloseButton={false}
        styles={{
          title: {
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '20px',
            fontWeight: 700,
            color: '#202224',
          },
          body: {
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '16px',
            color: '#595C60',
          },
          content: {
            borderRadius: 'none',
            border: 'none',
            boxShadow: '6px 6px 6px #00000040',
          },
        }}
      >
        <div>
          <p>
            This device is not licenced. You cannot access the drive details page for unlicensed devices. Please attach a licence to this device to view its details.
          </p>
          <div className="flex justify-end mt-4">
            <Button
              onClick={() => setIsUnlicencedModalOpen(false)}
              styles={{
                root: {
                  border: 'none ',
                  backgroundColor: '#FF7A00',
                  borderRadius: '20px',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                  '&:hover': {
                    backgroundColor: '#FF6B00',
                  },
                },
                label: {
                  fontFamily: 'Nunito Sans, sans-serif',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#fff',
                },
              }}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};  

export default DeviceTable;